module.exports = __webpack_public_path__ + "img/public/SiteIcons/correct.svg?4a86acfc";